import React, { Component } from 'react';
import './index.scss';
import { observer } from 'mobx-react';
import { createHashHistory } from 'history';
import store from '../../stores/category-store';


class TotalCategory extends Component {
  constructor(props, context){
    super(props);
  }

  componentDidMount(){
    store.loadAllCats();
    // console.log('componentDidMount');
    window._rlog.push('_trackPageview', [['show','show_secondCat']]);
    console.log('totalCategory componentDidMount');
    
    // console.log(store);
  }

  GotoTabs(superCatId, subCatId, deep, index, title){
    console.log('跳转到分类：'+superCatId);
    store.activeSecondTab = index;
    store.pageTitle = title;
    window._rlog.push([ "_trackCustom" , "EVENT", [['action', 'go_secondCat'],['secondCat', subCatId]] ]);
    createHashHistory().push('/CategoryList?superId='+ superCatId +'&subCatId='+subCatId+'&deep='+deep + '&title='+ encodeURIComponent(title));
  }
  
  render() {
    var me = this;
    return (
      <div className="total-category-list">
        {
          store.loaded && store.totalCats.map((item, index) => {
            return(
              <div className="top-cat-wrap" key={index} deep={item.info.deep}>
                <a onClick={() => me.GotoTabs(item.info.categoryId, 0 , item.info.deep, 0, item.info.name)} >
                  <h1 className="top-cat"><img src={item.image} alt="分类logo"/>{item.info.name}</h1>
                </a>
                <div className="second-cat-wrap">
                  {
                    item.subList && item.subList.map((list, index) => {
                      return(
                        <a key={index} className="second-cat"  onClick={() => me.GotoTabs(item.info.categoryId, list.categoryId, list.deep, index, item.info.name)}>
                          {list.name}
                        </a>
                      )
                    })
                  }
                </div>
                {/* <hr></hr> */}
              </div>
            ) 
          })
        }
      </div>
    );
  }
}

export default observer(TotalCategory);